import React from 'react'
import {UseFormMethods} from 'react-hook-form'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import Typography from 'Event/Dashboard/components/BlogPosts/Buttons/BlogPostButtonConfig/Styling/Typography'
import Background from 'Event/Dashboard/components/BlogPosts/Buttons/BlogPostButtonConfig/Styling/Background'
import Size from 'Event/Dashboard/components/BlogPosts/Buttons/BlogPostButtonConfig/Styling/Size'
import Border from 'Event/Dashboard/components/BlogPosts/Buttons/BlogPostButtonConfig/Styling/Border'
import ButtonStyleClipboardActions, {
  ButtonStyleClipboard,
} from 'lib/ui/Button/ButtonStyleClipboardActions'

export default function BaseStyling(props: {
  control: UseFormMethods['control']
  watch: UseFormMethods['watch']
  setValue: UseFormMethods['setValue']
  button: NavButtonWithSize
  inputNamePrefix: string
}) {
  const {control, button, watch, setValue, inputNamePrefix} = props

  const pasteButtonStyle = (style: ButtonStyleClipboard) => {
    const set = (name: string, value: unknown) => {
      if (value === undefined) {
        return
      }

      setValue(`${inputNamePrefix}${name}`, value, {shouldDirty: true})
    }

    set('disableHover', style.disableHover)

    // The hover color inputs only mount on the next render when the pasted
    // disableHover reveals them, so the rest is set a tick later.
    setTimeout(() => {
      set('font', style.font)
      set('fontSize', style.fontSize)
      set('textColor', style.textColor)
      set('hoverTextColor', style.hoverTextColor)
      set('backgroundColor', style.backgroundColor)
      set('hoverBackgroundColor', style.hoverBackgroundColor)
      set('borderColor', style.borderColor)
      set('hoverBorderColor', style.hoverBorderColor)
      set('borderWidth', style.borderWidth)
      set('borderRadius', style.borderRadius)
      set('height', style.height)
      set('size', style.widthGrid)
    }, 0)
  }

  return (
    <>
      <ButtonStyleClipboardActions
        values={{
          font: watch(`${inputNamePrefix}font`, button.font),
          fontSize: watch(`${inputNamePrefix}fontSize`, button.fontSize),
          textColor: watch(`${inputNamePrefix}textColor`, button.textColor),
          hoverTextColor: watch(
            `${inputNamePrefix}hoverTextColor`,
            button.hoverTextColor,
          ),
          backgroundColor: watch(
            `${inputNamePrefix}backgroundColor`,
            button.backgroundColor,
          ),
          hoverBackgroundColor: watch(
            `${inputNamePrefix}hoverBackgroundColor`,
            button.hoverBackgroundColor,
          ),
          disableHover: watch(
            `${inputNamePrefix}disableHover`,
            button.disableHover,
          ),
          borderColor: watch(
            `${inputNamePrefix}borderColor`,
            button.borderColor,
          ),
          hoverBorderColor: watch(
            `${inputNamePrefix}hoverBorderColor`,
            button.hoverBorderColor,
          ),
          borderWidth: watch(
            `${inputNamePrefix}borderWidth`,
            button.borderWidth,
          ),
          borderRadius: watch(
            `${inputNamePrefix}borderRadius`,
            button.borderRadius,
          ),
          height: watch(`${inputNamePrefix}height`, button.height),
          widthGrid: watch(`${inputNamePrefix}size`, button.size),
        }}
        onPaste={pasteButtonStyle}
      />
      <Typography
        button={button}
        control={control}
        inputNamePrefix={inputNamePrefix}
      />
      <Background
        button={button}
        control={control}
        inputNamePrefix={inputNamePrefix}
        watch={watch}
      />
      <Size
        button={button}
        control={control}
        inputNamePrefix={inputNamePrefix}
      />
      <Border
        button={button}
        control={control}
        inputNamePrefix={inputNamePrefix}
      />
    </>
  )
}
